"use client";

import { create } from "zustand";

/**
 * Single source of truth for the hero mockup's live upload progress.
 *
 * Why a store instead of three separate `useUploadProgress` hooks?
 *   The old version spawned one `requestAnimationFrame` per consumer
 *   and called `setState` 12×/sec in each — ~108 React reconciles/sec
 *   on the hero. The bar fill is now driven by direct DOM writes
 *   (see `useHeroProgressRef`), and the text components just subscribe
 *   to this store via a selector. One rAF, one state slice.
 */
type ProgressStore = {
  /** Integer 0..100 — the % shown in the UI. */
  progress: number;
  /** True while the rAF loop is allowed to advance. Pauses off-screen. */
  isActive: boolean;
  setProgress: (p: number) => void;
  setActive: (a: boolean) => void;
};

export const useUploadProgressStore = create<ProgressStore>((set) => ({
  progress: 12,
  isActive: false,
  setProgress: (p) => set({ progress: p }),
  setActive: (a) => set({ isActive: a })
}));
